import React from 'react';
import './styles.less';
import { Loader } from 'semantic-ui-react';

export const CustomLoader = () => {
	return (
		<div className="wrapper__custom-loader">
			<Loader active />
		</div>
	);
};
